"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundType = exports.SplitPaymentBy = exports.PaymentCardTypes = exports.POS_PAYMENT_CANCEL_MESSAGES = exports.PAYMENT_INPROGRESS_MESSAGES = exports.PaymentTypes = exports.DefaultPaymentTypes = exports.TerminalPrinterStatus = exports.TerminalStatus = exports.PaymentAction = exports.PaymentSubScreen = exports.PaymentMode = void 0;
var PaymentMode;
(function (PaymentMode) {
    PaymentMode["PAY_IN_FULL"] = "PAY_IN_FULL";
    PaymentMode["SPLIT_PAYMENT"] = "SPLIT_PAYMENT";
})(PaymentMode = exports.PaymentMode || (exports.PaymentMode = {}));
var PaymentSubScreen;
(function (PaymentSubScreen) {
    PaymentSubScreen["MAIN_SCREEN"] = "MAIN_SCREEN";
    PaymentSubScreen["PAYMENT_SUCCEEDED"] = "PAYMENT_SUCCEEDED";
    PaymentSubScreen["PAYOUT_SCREEN"] = "PAYOUT_SCREEN";
})(PaymentSubScreen = exports.PaymentSubScreen || (exports.PaymentSubScreen = {}));
var PaymentAction;
(function (PaymentAction) {
    PaymentAction["SET_PAYMENT_AMOUNT"] = "SET_PAYMENT_AMOUNT";
    PaymentAction["UPDATE_PAYMENT_AMOUNT"] = "UPDATE_PAYMENT_AMOUNT";
    PaymentAction["UPDATE_PAYMENT_MODE"] = "UPDATE_PAYMENT_MODE";
    PaymentAction["UPDATE_PAYMENT_INFO_FROM_ORDER"] = "UPDATE_PAYMENT_INFO_FROM_ORDER";
    PaymentAction["TAKE_NEXT_PAYMENT"] = "TAKE_NEXT_PAYMENT";
    PaymentAction["CANCEL_CURRENT_STEP"] = "CANCEL_CURRENT_STEP";
    PaymentAction["CANCEL_PAY_BY_SEAT"] = "CANCEL_PAY_BY_SEAT";
    PaymentAction["PAY_OUT"] = "PAY_OUT";
    PaymentAction["RESET_INITIAL_STATE"] = "RESET_INITIAL_STATE";
    PaymentAction["UPDATE_CUSTOMER_BALANCE_PAYMENT"] = "UPDATE_CUSTOMER_BALANCE_PAYMENT";
    PaymentAction["SETUP_NUMBER_OF_SPLIT_PAYMENT"] = "SETUP_NUMBER_OF_SPLIT_PAYMENT";
    PaymentAction["SPLIT_BY_SEAT"] = "SPLIT_BY_SEAT";
    PaymentAction["SELECT_SEAT_NUMBER"] = "SELECT_SEAT_NUMBER";
    PaymentAction["SPLIT_BY_PRODUCT"] = "SPLIT_BY_PRODUCT";
    PaymentAction["UPDATE_SELECTED_ORDER_ITEMS"] = "UPDATE_SELECTED_ORDER_ITEMS";
})(PaymentAction = exports.PaymentAction || (exports.PaymentAction = {}));
var TerminalStatus;
(function (TerminalStatus) {
    TerminalStatus["OK"] = "OK";
    TerminalStatus["BUSY"] = "BUSY";
    TerminalStatus["MAINTENANCE"] = "MAINTENANCE";
    TerminalStatus["UNREACHABLE"] = "UNREACHABLE";
})(TerminalStatus = exports.TerminalStatus || (exports.TerminalStatus = {}));
var TerminalPrinterStatus;
(function (TerminalPrinterStatus) {
    TerminalPrinterStatus["OK"] = "OK";
    TerminalPrinterStatus["PAPER_LOW"] = "PAPER_LOW";
    TerminalPrinterStatus["NO_PAPER"] = "NO_PAPER";
    TerminalPrinterStatus["PAPER_JAM"] = "PAPER_JAM";
    TerminalPrinterStatus["OUT_OF_ORDER"] = "OUT_OF_ORDER";
})(TerminalPrinterStatus = exports.TerminalPrinterStatus || (exports.TerminalPrinterStatus = {}));
var DefaultPaymentTypes;
(function (DefaultPaymentTypes) {
    DefaultPaymentTypes["CARD"] = "Card";
    DefaultPaymentTypes["ONLINE"] = "Online";
    DefaultPaymentTypes["CASH"] = "Cash";
    DefaultPaymentTypes["ON_ACCOUNT"] = "On Account";
    DefaultPaymentTypes["SEVENROOMS"] = "Sevenrooms";
})(DefaultPaymentTypes = exports.DefaultPaymentTypes || (exports.DefaultPaymentTypes = {}));
var PaymentTypes;
(function (PaymentTypes) {
    PaymentTypes["CARD"] = "Card";
    PaymentTypes["ONLINE"] = "Online";
    PaymentTypes["CASH"] = "Cash";
    PaymentTypes["ON_ACCOUNT"] = "On Account";
    PaymentTypes["SEVENROOMS"] = "Sevenrooms";
})(PaymentTypes = exports.PaymentTypes || (exports.PaymentTypes = {}));
exports.PAYMENT_INPROGRESS_MESSAGES = ['Uncompleted transaction'];
exports.POS_PAYMENT_CANCEL_MESSAGES = [
    '104 Merchant cancelled tx',
    '224 Merchant cancelled during authorize online',
    'Transaction aborted',
];
var PaymentCardTypes;
(function (PaymentCardTypes) {
    PaymentCardTypes["VISA"] = "visa";
    PaymentCardTypes["VISA_DEBIT"] = "visa_debit";
    PaymentCardTypes["VISA_CREDIT"] = "visa_credit";
    PaymentCardTypes["MASTERCARD"] = "mc";
    PaymentCardTypes["MASTERCARD_DEBIT"] = "mc_debit";
    PaymentCardTypes["MASTERCARD_CREDIT"] = "mc_credit";
    PaymentCardTypes["AMERICAN_EXPRESS"] = "amex";
    PaymentCardTypes["EFTPOS_SAVING"] = "eftpos_australia_sav";
    PaymentCardTypes["EFTPOS_CHQ"] = "eftpos_australia_chq";
    PaymentCardTypes["OTHER"] = "other";
})(PaymentCardTypes = exports.PaymentCardTypes || (exports.PaymentCardTypes = {}));
var SplitPaymentBy;
(function (SplitPaymentBy) {
    SplitPaymentBy["BY_PRODUCT"] = "BY_PRODUCT";
    SplitPaymentBy["BY_AMOUNT"] = "BY_AMOUNT";
    SplitPaymentBy["BY_SEAT"] = "BY_SEAT";
})(SplitPaymentBy = exports.SplitPaymentBy || (exports.SplitPaymentBy = {}));
var RefundType;
(function (RefundType) {
    RefundType["FULL"] = "FULL";
    RefundType["BY_AMOUNT"] = "BY_AMOUNT";
    RefundType["By_PRODUCT"] = "By_PRODUCT";
})(RefundType = exports.RefundType || (exports.RefundType = {}));
//# sourceMappingURL=payments.js.map